































import { Vue, Component } from 'vue-property-decorator';
import {AMAZON_RETURNS_ROUTES} from "@/constants/routes";

@Component({
  name: 'AmazonReturnsStart',
  components: {
  },
})
export default class AmazonReturnsStart extends Vue {
  private next() {
    this.$router.push({name: AMAZON_RETURNS_ROUTES.FORM});
  }
}
